import { Injectable } from '@angular/core';

import { objectToQueryString } from '../../common/utils';

import { environment } from '../../../environments/environment';

import { RestService } from './rest.service';

@Injectable()
export class DelegateTypeService {
  constructor(private readonly rest: RestService) {}

  getDelegateTypes(search: string = ''): Promise<any> {
    const query = objectToQueryString({
      search,
    });

    return this.rest.get(`${environment.apiUrl}/api/core/delegate-type${query}`);
  }

  getDelegateTypeById(id: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/delegate-type/${id}`);
  }

  createDelegateType(payload: any): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/delegate-type`, payload);
  }

  updateDelegateType(id: number, payload: any): Promise<any> {
    return this.rest.put(`${environment.apiUrl}/api/core/delegate-type/${id}`, payload);
  }

  deleteDelegateType(id: number): Promise<any> {
    return this.rest.delete(`${environment.apiUrl}/api/core/delegate-type/${id}`);
  }
}
